import { render, staticRenderFns } from "./VActionableActions.vue?vue&type=template&id=935c2c1e&scoped=true&"
import script from "./VActionableActions.vue?vue&type=script&lang=js&"
export * from "./VActionableActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935c2c1e",
  null
  
)

export default component.exports